var React = require('react');

function ChevRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("g",{"id":"Community","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Anchor-Navigation-&-Table","transform":"translate(-195.000000, -910.000000)","fill":"#B89061","fillRule":"nonzero"},React.createElement("g",{"id":"chevron-right-round-24px","transform":"translate(186.000000, 904.000000)"},React.createElement("path",{"d":"M9.29,6.71 C8.9,7.1 8.9,7.73 9.29,8.12 L13.17,12 L9.29,15.88 C8.9,16.27 8.9,16.9 9.29,17.29 C9.68,17.68 10.31,17.68 10.7,17.29 L15.29,12.7 C15.68,12.31 15.68,11.68 15.29,11.29 L10.7,6.7 C10.32,6.32 9.68,6.32 9.29,6.71 Z","id":"Path"}))))]);
}

ChevRight.defaultProps = {"width":"7px","height":"12px","viewBox":"0 0 7 12","version":"1.1"};

module.exports = ChevRight;

ChevRight.default = ChevRight;
